import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';
import LanguageSwitcher from '../LanguageSwitcher';

const AuthLayout = () => {
  const { isAuthenticated, loading } = useAuth();
  const { t } = useTranslation('common');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-jc-bg text-jc">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 mb-4">
            <Loader2 className="w-8 h-8 text-blue-600 animate-spin" />
          </div>
          <p className="text-jc-muted font-medium">{t('state.loading')}</p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <Outlet />
      {/*
        One switcher covers all three auth routes (login, forgot password,
        organization signup) instead of each page carrying its own.

        It has to be reachable BEFORE sign-in: the stored preference is
        per-browser, so a workshop's first Arabic-speaking user meets the
        product at the login screen with no other way to change language.

        Pinned to the inline-end edge, which puts it in the top-right in
        English and the top-left in Arabic — the far corner from where reading
        starts, in both directions, so it never lands on the heading.
      */}
      <div className="fixed top-4 end-4 z-50">
        <LanguageSwitcher />
      </div>
    </>
  );
};

export default AuthLayout;
